var symphony = symphony || {};

;
(function () {

	symphony.waysToGiveMasonGrid = null;
	symphony.waysToGiveGrid = function () {

		if (symphony.waysToGiveMasonGrid != null) {
			symphony.waysToGiveMasonGrid.destroy();
			setTimeout(function () {
				symphony.waysToGiveMasonGrid = null;
				symphony.waysToGiveGrid();
			}, 300);
		}
		if ($("#grid-fixed").length > 0) {
			symphony.waysToGiveMasonGrid = $("#grid-fixed").mason({
				itemSelector: '.givingGrid-item',
				ratio: 1.5,
				sizes: [
					[1, 2],
					[2, 1],
					[2, 2]
				],
				columns: [
					[0, 480, 1],
					[480, 780, 2],
					[780, 1080, 3],
					[1080, 3200, 4]
				],
				filler: {
					itemSelector: '.givingGrid-filler',
					filler_class: 'mason_filler'
				},
				gutter: 12,
				layout: 'fluid'
			});
		}

	};


})();
